import { render, staticRenderFns } from "./downloadGame.vue?vue&type=template&id=450a5f7d&scoped=true"
import script from "./downloadGame.vue?vue&type=script&lang=js"
export * from "./downloadGame.vue?vue&type=script&lang=js"
import style0 from "./downloadGame.vue?vue&type=style&index=0&id=450a5f7d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450a5f7d",
  null
  
)

export default component.exports